import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ResponsiveMode } from '../../../enum/responsiveModes';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SharedService } from '../../../_services/shared.service';
import Utils from '../../../_utils/utils';
import { Offer } from '../../../model/offer';
import { NgOptimizedImage } from '@angular/common'
import { NgImageSliderModule } from 'ng-image-slider';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { OfferPhotoGalleryComponent } from '../../offer-photo-gallery/offer-photo-gallery.component';

@Component({
  selector: 'app-offer-image',
  standalone: true,
  imports: [CommonModule, 
            NgOptimizedImage,
            OfferPhotoGalleryComponent,
            NgImageSliderModule],
  templateUrl: './offer-image.component.html',
  styleUrl: './offer-image.component.css'
})
export class OfferImageComponent implements OnInit {


  @Input()
  offer!: Offer | null;
  @Input()
  index: number = 0;

  imageIndex: number = 0;

  modalRef!: BsModalRef;
  viewMode: string = ResponsiveMode.horizontal;

  imageObject: Array<object> = [];

  constructor(private responsive: BreakpointObserver,
              private modalService: BsModalService, 
              public sharedService: SharedService) {

  }

  ngOnInit(): void {

    this.responsive.observe([
      Breakpoints.HandsetPortrait,
    ])
      .subscribe(result => {

        const breakpoints = result.breakpoints;

        if(breakpoints[Breakpoints.HandsetPortrait]){
          this.viewMode = ResponsiveMode.vertical;
        }else {
          this.viewMode = ResponsiveMode.horizontal;
        }          

      });

      this.offer?.amenities.room_photo_urls.forEach((url: string) => {  
        this.imageObject.push({
          image: url,
          thumbImage: url,
          title: '',
          alt: '',
        }); 

      });


  }


  openModal(template: TemplateRef<any>) {
    
    if(this.offer) {
      this.sharedService.setSelectedOfferByOffer(this.index, this.offer, false);
    }    
    this.modalRef = this.modalService.show(template, this.sharedService.config); 
  }

  changeImage(event: any) {
    
    if(event.action==='next'){
      this.imageIndex = this.imageIndex + 1
    }else if(event.action==='previous'){
      this.imageIndex = this.imageIndex - 1      
    }

    if(this.imageIndex < 0) {
      this.imageIndex = this.imageObject.length - 1;
    }

    if(this.imageIndex > this.imageObject.length - 1) {
      this.imageIndex = 0;
    }

  }

  responsiveStyle(styleObj: {[key: string]: string}): {[key: string]: boolean} {   
    return Utils.responsiveStyle(this.viewMode, styleObj)
  } 





}
